function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { Text, TextVariant } from '@naf/text';
import { breakpoints, radius, spacing } from '@naf/theme';
import { propValidationConfig } from '../propValidationConfig';
function ImageRenderer({
  advancedImage,
  img,
  illustration
}) {
  if (advancedImage) {
    return /*#__PURE__*/React.createElement(ImageContainer, null, advancedImage);
  }
  if (img) {
    return /*#__PURE__*/React.createElement(ImageContainer, null, /*#__PURE__*/React.createElement(StyledImage, {
      src: img.src,
      alt: img.alt,
      objectFit: img.objectFit
    }));
  }
  if (illustration) {
    return /*#__PURE__*/React.createElement(ImageContainer, null, /*#__PURE__*/React.createElement(StyledImage, {
      src: illustration.src,
      alt: illustration.alt,
      objectFit: illustration.objectFit
    }));
  }
  return /*#__PURE__*/React.createElement(ImageContainer, null, /*#__PURE__*/React.createElement(ImagePlaceholder, null));
}
export const LinkBanner = /*#__PURE__*/forwardRef(({
  title,
  advancedImage,
  img,
  illustration,
  imageAlignment = {
    horizontal: 'right',
    relativeSize: 50,
    vertical: 'below'
  },
  children,
  ...rest
}, ref) => {
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(TextWrapper, {
    relativeSize: imageAlignment.relativeSize
  }, /*#__PURE__*/React.createElement(Title, {
    tag: "h2",
    variant: TextVariant.Header2
  }, title), children), /*#__PURE__*/React.createElement(ImageWrapper, {
    alignment: imageAlignment
  }, /*#__PURE__*/React.createElement(ImageRenderer, {
    advancedImage: advancedImage,
    illustration: illustration,
    img: img
  })));
});
const ImagePlaceholder = styled.div.withConfig({
  displayName: "linkBanner__ImagePlaceholder",
  componentId: "sc-5nm6uy-0"
})(["background:lightgrey;"]);
const StyledImage = styled.img.withConfig(propValidationConfig).withConfig({
  displayName: "linkBanner__StyledImage",
  componentId: "sc-5nm6uy-1"
})(["min-height:100%;min-width:100%;object-fit:", ";@media (max-width:", "){object-fit:contain;max-height:100%;max-width:100%;}"], ({
  objectFit
}) => objectFit === 'contain' ? 'contain' : 'cover', breakpoints.s);
const ImageContainer = styled.div.withConfig({
  displayName: "linkBanner__ImageContainer",
  componentId: "sc-5nm6uy-2"
})(["width:100%;position:relative;img,", ",", "{object-fit:cover;left:0;top:0;height:100%;width:100%;border-radius:", ";}"], ImagePlaceholder, StyledImage, radius.s);
const Wrapper = styled.div.withConfig({
  displayName: "linkBanner__Wrapper",
  componentId: "sc-5nm6uy-3"
})(["display:flex;flex-direction:column;@media (min-width:", "){justify-content:space-between;flex-direction:row;align-items:start;}"], breakpoints.s);
const Title = styled(Text).withConfig({
  displayName: "linkBanner__Title",
  componentId: "sc-5nm6uy-4"
})(["margin-top:0;"]);
const TextWrapper = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "linkBanner__TextWrapper",
  componentId: "sc-5nm6uy-5"
})(["align-self:center;@media (max-width:", "){align-self:start;}@media (min-width:", "){flex-basis:", ";}"], breakpoints.m, breakpoints.s, ({
  relativeSize
}) => relativeSize ? `${100 - relativeSize}%` : '40%');
const ImageWrapper = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "linkBanner__ImageWrapper",
  componentId: "sc-5nm6uy-6"
})(["", ";@media (min-width:", "){flex-basis:", ";display:flex;justify-content:flex-end;", "}"], ({
  alignment
}) => alignment && css(["order:", ";margin:", ";"], alignment.vertical === 'above' ? -1 : 1, alignment.vertical === 'above' ? `0 0 ${spacing.space16} 0` : `${spacing.space16} 0 0 0`), breakpoints.s, ({
  alignment
}) => alignment && alignment.relativeSize ? `${alignment.relativeSize}%` : '60%', ({
  alignment
}) => alignment && css(["order:", ";margin:", ";"], alignment.horizontal === 'left' ? -1 : 1, alignment.horizontal === 'left' ? `0 ${spacing.space32} 0 0` : `0 0 0 ${spacing.space32}`));
//# sourceMappingURL=linkBanner.js.map